import actions from "@/core/store/modules/errors/actions";
import getters from "@/core/store/modules/errors/getters";
import mutations from "@/core/store/modules/errors/mutations";


export default {
    state: {
        validationErrors: {},
        status: null
    },
    getters,
    mutations,
    actions
}